// Раздел «Рынок»: цены рыбы и морепродуктов по звеньям цепочки.
//
// Вкладки: «Экспорт» — таможня импортёров (Ф3), «Опт» — первая продажа за
// рубежом (Ф4), «Розница» — Росстат (Ф6) и, внутреннему кабинету, цены сетей Tonusmeal, «Сводка» — покрытие источников
// (`/cabinet/prices/summary`), «Аналитика» — цепочка, сезонность, валюта, квоты (Ф8). Отказ признака — общий: обе ручки за одним гейтом.

import { useQuery } from '@tanstack/react-query'
import { cabinetApi } from '../api'
import { useT } from '../i18n'
import { AnalyticsPanel } from './AnalyticsPanel'
import { CustomsPanel } from './CustomsPanel'
import { RetailSection } from './RetailPanel'
import { isPricesForbidden } from './pricesState'
import { PRICES_TABS, parseTab, usePricesUrl } from './pricesUrl'

export function PricesPage() {
  const t = useT()
  const url = usePricesUrl()
  const tab = parseTab(url.get('tab'))
  const setTab = (k: (typeof PRICES_TABS)[number]) => url.set({ tab: k === 'export' ? null : k })
  const { data, error, isLoading } = useQuery({
    queryKey: ['cabinet', 'prices', 'summary'],
    queryFn: () => cabinetApi.pricesSummary(),
    retry: false,
  })
  return (
    <div className="mx-auto h-full max-w-5xl overflow-y-auto p-6">
      <h1 className="mb-4 text-xl font-semibold tracking-tight text-foam">{t('prices.title')}</h1>
      {!error && (
        <div className="mb-5 flex gap-4 border-b border-line text-sm">
          {PRICES_TABS.map((k) => (
            <button key={k} type="button" onClick={() => setTab(k)}
              className={`-mb-px border-b-2 pb-2 ${tab === k
                ? 'border-accent text-foam' : 'border-transparent text-mist hover:text-foam'}`}>
              {t(`prices.tab.${k}`)}
            </button>
          ))}
        </div>
      )}
      {!error && tab === 'export' && <CustomsPanel key="export" market="export" />}
      {!error && tab === 'wholesale' && <CustomsPanel key="wholesale" market="wholesale" />}
      {!error && tab === 'wholesale_ru' && <CustomsPanel key="wholesale_ru" market="wholesale_ru" />}
      {!error && tab === 'retail' && <RetailSection />}
      {!error && tab === 'analytics' && <AnalyticsPanel />}
      {isLoading && <p className="text-sm text-mist">{t('prices.loading')}</p>}
      {error && (
        <p className="text-sm text-mist">
          {isPricesForbidden(error) ? t('errors.prices_forbidden') : t('prices.error')}
        </p>
      )}
      {data && tab === 'summary' && (
        <div className="space-y-2 text-sm">
          {data.live === 0 && <p className="text-foam">{t('prices.empty')}</p>}
          <p className="text-mist">
            {t('prices.coverage', { sources: data.sources, live: data.live, items: data.items })}
          </p>
        </div>
      )}
    </div>
  )
}
